import { useSetAtom } from 'jotai';
import { Button } from '@mui/material';

import {
  pageAtom,
  isBackdropOpenAtom,
  snackbarPropsAtom,
} from '../../../atoms';
import { PAGE } from '../../../constant/page';
import { ApiAccounts } from '../../../api/apiAccounts';
import { defaultAccount } from '../../../types/account';
import { Dispatch, SetStateAction } from 'react';
import { registerMailAtom } from '../../../atoms/emailAtoms';

const RegistrationButton = (props: {
  formData: {
    email: string;
    password: string;
    lastName: string;
    firstName: string;
    company: string;
    address: string;
    phone: string;
    industry: string[];
    country: string;
    state: string;
    language: string;
  };
  formValidation: {
    email: boolean;
    password: boolean;
    lastName: boolean;
    firstName: boolean;
    company: boolean;
    address: boolean;
    phone: boolean;
    industry: boolean;
    country: boolean;
    state: boolean;
    language: boolean;
  };
  setFormValidation: Dispatch<
    SetStateAction<{
      email: boolean;
      password: boolean;
      lastName: boolean;
      firstName: boolean;
      company: boolean;
      address: boolean;
      phone: boolean;
      industry: boolean;
      country: boolean;
      state: boolean;
      language: boolean;
    }>
  >;
}) => {
  const { formData, formValidation, setFormValidation } = props;
  const setPage = useSetAtom(pageAtom);
  const setRegisterEmail = useSetAtom(registerMailAtom);
  const setIsBackdropOpen = useSetAtom(isBackdropOpenAtom);
  const setSnackbarProps = useSetAtom(snackbarPropsAtom);

  const validateForm = () => {
    const newFormValidation = {
      ...formValidation,
    };

    if (formData.email === '') {
      newFormValidation.email = false;
    }
    if (formData.password === '') {
      newFormValidation.password = false;
    }
    if (formData.firstName === '') {
      newFormValidation.firstName = false;
    }
    if (formData.lastName === '') {
      newFormValidation.lastName = false;
    }
    if (formData.company === '') {
      newFormValidation.company = false;
    }

    if (Object.values(newFormValidation).includes(false)) {
      setFormValidation(newFormValidation);
      return false;
    }

    return true;
  };

  const onClickRegistration = () => {
    // guard block
    if (!validateForm()) {
      return;
    }

    setIsBackdropOpen(true);
    ApiAccounts.post({ ...defaultAccount, ...formData })
      .then(() => {
        setRegisterEmail(formData.email);
        setPage(PAGE.REGISTRATION_MAIL);
      })
      .catch((error) => {
        console.log(error);
        setSnackbarProps({
          isOpen: true,
          message: 'アカウントの作成に失敗しました。',
          type: 'error',
        });
      })
      .finally(() => {
        setIsBackdropOpen(false);
      });
  };

  return (
    <Button
      variant='contained'
      sx={{ width: '150px' }}
      color='primary'
      onClick={onClickRegistration}
    >
      登録
    </Button>
  );
};

export default RegistrationButton;
